import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "ref", "transform", "transformOrigin", "style"];
import styled from 'foundations-theming/utils';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterProps } from 'foundations-components/utils/filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
const ToolbarIconButtonGroupWrapper = styled.div.withConfig({
  displayName: "ToolbarIconButtonGroup__ToolbarIconButtonGroupWrapper",
  componentId: "sc-1pz3qlx-0"
})([".hs-private.hs-private.hs-private &{position:relative;display:flex;white-space:nowrap;flex-direction:row;transform:", ";transform-origin:", ";", "}"], ({
  $transform
}) => $transform, ({
  $transformOrigin
}) => $transformOrigin, ({
  $cssStyles
}) => $cssStyles);

// Omit inset shorthand because we want consumers to explicitly pass through
// each inset property in case we need to adjust the position
const ToolbarIconButtonGroup = _ref => {
  let {
      children,
      ref,
      transform = 'none',
      transformOrigin = 'none',
      style
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps,
    domProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(ToolbarIconButtonGroupWrapper, Object.assign({
      ref: ref,
      style: style,
      $cssStyles: cssStyles,
      $transform: transform,
      $transformOrigin: transformOrigin
    }, domProps, {
      children: children
    }))
  );
};
export default ToolbarIconButtonGroup;